import React from "react";
import "../styles/Home.css";
import UsePageTitle from "../components/UsePageTitle";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import Logo from "../resources/images/Footer_Logo.svg";
import OurExpertise from "../components/OurExpertise";
import DownArrow from "../resources/images/Down_Arrow.svg";
import { motion } from "framer-motion";

const AboutUs = () => {
  UsePageTitle("About Us | Bravix Group");
  const containerVariant = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const paragraphVariant = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <>
      <Navbar />
      <section className="about_section">
        <div className="container h-100">
          <div className="row h-100">
            <div className="about_content_main">
              <div className="about_content">
                <motion.img
                  src={Logo}
                  alt="Logo"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ amount: 0.3 }}
                />

                <motion.h1
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                  viewport={{ amount: 0.3 }}
                >
                  About Us
                </motion.h1>

                <motion.p
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ amount: 0.3 }}
                >
                  Strengthening Commercial Construction through strategic talent
                  solutions
                </motion.p>

                <motion.button
                  className="down_arrow_btn"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  viewport={{ amount: 0.3 }}
                >
                  <img src={DownArrow} alt="DownArrow" />
                </motion.button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="who_we_are">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="who_we_are_top">
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ amount: 0.3 }}
                >
                  About us
                </motion.p>

                <motion.h5
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  viewport={{ amount: 0.3 }}
                >
                  Who We Are
                </motion.h5>
              </div>
              <div className="who_we_are_bottom who_we_margin">
                <motion.p
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  viewport={{ amount: 0.3 }}
                >
                  Bravix Group was founded to provide tailored recruitment
                  solutions that truly meet the unique needs of the commercial
                  construction industry. We saw a real need to connect companies
                  with skilled professionals who are looking for more than just
                  a job – they want work that's rewarding and builds something
                  meaningful.
                </motion.p>
                <motion.p
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.5 }}
                  viewport={{ amount: 0.3 }}
                >
                  Our approach is all about adding value-helping businesses
                  build stronger teams while empowering professionals to find
                  opportunities where their skills make a tangible impact. We
                  focus on delivering the right talent for every project,
                  ensuring companies have the skilled professionals they need to
                  succeed.
                </motion.p>
                <motion.p
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.8 }}
                  viewport={{ amount: 0.3 }}
                >
                  At Bravix Group, we're passionate about making sure both
                  companies and workers thrive. We bring together the right
                  people to get the job done right, creating lasting impact on
                  every project. Whether you're looking to grow your team or
                  advance your career, we're here to help ensure the work you do
                  matters.
                </motion.p>
              </div>
              <div className="who_we_are_top">
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ amount: 0.3 }}
                >
                  About us
                </motion.p>

                <motion.h5
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  viewport={{ amount: 0.3 }}
                >
                  Why Bravix?
                </motion.h5>
              </div>
              <motion.div
                className="who_we_are_bottom"
                variants={containerVariant}
                initial="hidden"
                whileInView="show"
                viewport={{ amount: 0.3 }}
              >
                <motion.p variants={paragraphVariant}>
                  <span>Industry Expertise –</span> We specialize in Commercial
                  Construction, connecting you with skilled professionals who
                  drive project success and company growth.
                </motion.p>
                <motion.p variants={paragraphVariant}>
                  <span>Tailored Recruitment –</span> Working as an extension of
                  your team, we ensure every candidate matches both your
                  technical requirements and company culture.
                </motion.p>
                <motion.p variants={paragraphVariant}>
                  <span>Access to Talent –</span> We reach qualified
                  professionals who aren't on job boards but are open to the
                  right opportunity that advances their career.
                </motion.p>
                <motion.p variants={paragraphVariant}>
                  <span>Brand Advocacy –</span> As we network throughout the
                  industry, we position your company as an employer of choice to
                  attract top talent.
                </motion.p>
                <motion.p variants={paragraphVariant}>
                  <span>Market Insights –</span> We provide valuable insights on
                  hiring trends, competitive compensation, and industry
                  developments to inform your talent strategy.
                </motion.p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      <OurExpertise />
      <Footer />
    </>
  );
};

export default AboutUs;
